import { __assign } from "tslib";
var AbsoluteLengthUnitSuffix = {
    Pixel: 'px',
    Centimeter: 'cm',
    Millimeter: 'mm',
    Quarter: 'Q',
    Inch: 'in',
    Pica: 'pc',
    Point: 'pt',
};
var RelativeLengthUnitSuffix = {
    REM: 'rem',
    EM: 'em',
    ViewWidth: 'vw',
    ViewHeight: 'vh',
    ViewMin: 'vmin',
    ViewMax: 'vmax',
};
var MultiplicationUnitSuffix = {
    Percent: '%',
    Magnification: '',
};
var LengthUnitSuffix = __assign(__assign({}, AbsoluteLengthUnitSuffix), RelativeLengthUnitSuffix);
export var UnitSuffix = __assign(__assign({}, LengthUnitSuffix), MultiplicationUnitSuffix);
//# sourceMappingURL=defs.js.map